import * as Yup from 'yup';

export interface IInsuranceInfo {
  companyName: string;
  insuranceNumber: string;
}

export const insuranceInfoValidationSchema = Yup.object<
  any,
  Partial<Record<keyof IInsuranceInfo, Yup.AnySchema>>
>({
  companyName: Yup.string()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .notRequired(),
  insuranceNumber: Yup.string()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .matches(/^\d\d\d \d\d\d \d\d\d\d$/, { excludeEmptyString: true })
    .notRequired(),
});
